import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AdminAuthProvider } from "./context/AdminAuth";
import PublicSite from "./pages/PublicSite";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminStats from "./pages/admin/AdminStats";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminClub from "./pages/admin/AdminClub";
import AdminContacts from "./pages/admin/AdminContacts";
import AdminVotes from "./pages/admin/AdminVotes";
import AdminLoyalty from "./pages/admin/AdminLoyalty";
import LoyaltyCard from "./pages/LoyaltyCard";
import LoyaltyScan from "./pages/LoyaltyScan";
import NotFound from "./pages/NotFound";
import Commander from "./pages/Commander";
import OrderConfirmation from "./pages/OrderConfirmation";
import AdminAvailability from "./pages/admin/AdminAvailability";
import AdminReviews from "./pages/admin/AdminReviews";

// Google Analytics 4 — injected only if REACT_APP_GA4_ID is set in env.
const useGA4 = () => {
  useEffect(() => {
    const id = process.env.REACT_APP_GA4_ID;
    if (!id || window.gtag) return;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", id, { anonymize_ip: true });
  }, []);
};

function App() {
  useGA4();
  return (
    <div className="App">
      <BrowserRouter>
        <AdminAuthProvider>
          <Routes>
            <Route path="/" element={<PublicSite />} />
            <Route path="/commander" element={<Commander />} />
            <Route path="/commande/:orderId" element={<OrderConfirmation />} />
            <Route path="/carte-fidelite" element={<LoyaltyCard />} />
            <Route path="/s/:cardId" element={<LoyaltyScan />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminStats />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="availability" element={<AdminAvailability />} />
              <Route path="reviews" element={<AdminReviews />} />
              <Route path="club" element={<AdminClub />} />
              <Route path="contacts" element={<AdminContacts />} />
              <Route path="votes" element={<AdminVotes />} />
              <Route path="loyalty" element={<AdminLoyalty />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </AdminAuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "white",
            color: "#2a2422",
            border: "1px solid rgba(229,91,91,0.2)",
            borderRadius: "9999px",
            padding: "12px 20px",
            fontFamily: "Nunito, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
